import React from 'react';

const LoginBackground = () => {
  return (
    <div className="login-page-background-container">
      <div className="login-page-background-gradient"></div>
      <div></div>
    </div>
  );
};

export default LoginBackground;
